import styled from 'styled-components';
import { ReactComponent as FileIcon } from '../../utils/File.svg';
import { ReactComponent as CloseIcon } from '../../utils/Close.svg';
import { Typography } from '../../../Typography';
import { MEDIA_QUERY } from '../../../Theme';

export const UploadedFileWrapper = styled.div`
  align-items: center;
  background-color: ${({ theme }) => `${theme.palette.commons.tonal.hover}`};
  border-radius: 8px;
  color: ${({ theme }) => `${theme.palette.text.paragraph.primary}`};
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 10px;
  outline: none;
  padding: 15px;
  transition: border 0.24s ease-in-out;
`;
export const FileIconStyled = styled(FileIcon)`
  fill: transparent;
  margin-right: 5px;
  stroke: ${(p) => p.theme.palette.brand.color};
`;

export const CloseIconStyled = styled(CloseIcon)`
  cursor: pointer;
  fill: ${({ theme }) => theme.palette.brand.color};
`;
export const TypographyGlobalStyle = styled(Typography)`
  margin: 0;
  padding: 0;
`;

export const FileInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const FileInfo = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
`;
export const ExtraActionsWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const FileTitle = styled(TypographyGlobalStyle)`
  font-weight: bold;
  ${MEDIA_QUERY.below('sm')} {
    font-size: 0.85rem;
    line-height: 1;
  }
`;
